import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { IChangePassData, IRegisterData } from 'types/common.types';
import { IResetPassData } from './../types/common.types';

export const registrationApi = createApi({
	reducerPath: 'registrationApi',
	baseQuery: fetchBaseQuery({
		baseUrl: `https://${CONFIG.pasportApi}/`,
	}),
	endpoints: (build) => ({
		register: build.mutation<any, IRegisterData>({
			query: (body) => ({
				url: 'custom_auth_registration/registration/',
				method: 'POST',
				body
			})
		}),
		changePass: build.mutation<any, IChangePassData>({
			query: (body) => ({
				url: 'custom_auth_registration/password_changing/',
				method: 'POST',
				body
			})
		}),
		resetPass: build.mutation<any, IResetPassData>({
			query: (body) => ({
				url: 'custom_auth_registration/reset_password/',
				method: 'POST',
				body
			})
		})
	})
});
